import { useState, useEffect } from 'react';

import { useQueryClient } from 'react-query';

import { CONTEXT_MODE_ELEMENTARY_AND_SECONDARY } from 'components/Common/LayoutV2/utils';
import Api from 'core/api';
import useMutation from 'hooks/useMutation';

const useBulkMatch = ({ toggleFilter, removeFilter }) => {
  const [matchEntriesBoxValue, setMatchEntriesBoxValue] = useState('');
  const [matchType, setMatchType] = useState('');
  const [matchedCount, setMatchedCount] = useState(0);
  const [notMatchedList, setNotMatchedList] = useState([]);
  const [duplicateList, setDuplicateList] = useState([]);
  const queryClient = useQueryClient();

  const [isBulkMatchListEnabled, setBulkMatchListEnabledStatus] =
    useState(false);

  const {
    isFetching,
    data: bulkMatchResults,
    mutate: submitBulkMatch,
  } = useMutation({
    apiFunc: payload => Api.slUsers.bulkMatchStudents(payload),
    onSuccess: data => {
      toggleFilter({
        group: 'bulkMatch',
        id: 'bulkMatch',
        label: `${data?.data?.matchType ?? 'name'}`,
        source: 'bulkMatch',
        singleFilter: true,
        addOnly: true,
      });
      queryClient.invalidateQueries('bulkSelect.selectedList');
      queryClient.invalidateQueries('bulkSelect.availableList');
    },
  });

  useEffect(() => {
    if (bulkMatchResults) {
      const {
        data: { matched, noMatch, duplicateMatch, matchType: matchTypeResult },
      } = bulkMatchResults;

      setMatchedCount(matched.count);
      setNotMatchedList(noMatch.rawIdentifiers);
      setDuplicateList(duplicateMatch.rawIdentifiers);
      setBulkMatchListEnabledStatus(true);
      setMatchType(matchTypeResult);
    }
  }, [bulkMatchResults]);

  const sendRequest = payload => {
    submitBulkMatch({
      data: payload,
      params: { studentScope: CONTEXT_MODE_ELEMENTARY_AND_SECONDARY },
    });
  };

  const clearMatchEntriesBox = () => {
    setBulkMatchListEnabledStatus(false);
    setMatchEntriesBoxValue('');
    setMatchedCount(0);
    setNotMatchedList(0);
    setDuplicateList(0);
    setMatchType('');
    removeFilter('bulkMatch');
  };

  return {
    isLoading: isFetching,
    clearMatchEntriesBox,
    isBulkMatchListEnabled,
    setBulkMatchListEnabledStatus,
    matchEntriesBoxValue,
    setMatchEntriesBoxValue,
    matchedCount,
    setMatchedCount,
    notMatchedList,
    setNotMatchedList,
    duplicateList,
    setDuplicateList,
    data: bulkMatchResults,
    sendRequest,
    matchType,
  };
};

export default useBulkMatch;
